import { render, staticRenderFns } from "./ArticleSortBy.vue?vue&type=template&id=336ecc98&scoped=true"
import script from "./ArticleSortBy.vue?vue&type=script&lang=js"
export * from "./ArticleSortBy.vue?vue&type=script&lang=js"
import style0 from "./ArticleSortBy.vue?vue&type=style&index=0&id=336ecc98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336ecc98",
  null
  
)

export default component.exports